import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const CommentRoutes: RouteRecordRaw = {
  path: '/comment',
  name: 'CommentModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageCommentRoute',
      component: () => import('./views/ManageCommentView.vue'),
      meta: {
        title: 'کامنت‌ها',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.comment,
  },
}

export default (router: Router) => {
  router.addRoute(CommentRoutes)
}
